"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioTile = void 0;
var React = _interopRequireWildcard(require("react"));
var _common = require("../../types/common");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Card = require("../Card");
var _Chip = require("../Chip");
var _Icon = require("../Icon");
var _RadioButton = require("../RadioButton");
var _Text = require("../Text");
var _RadioTileModule = _interopRequireDefault(require("./RadioTile.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const RadioTile = exports.RadioTile = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    id,
    semantic = _common.ALERT_SEMANTIC.neutral,
    header,
    description,
    chipItems,
    iconName,
    iconSize = _Icon.ICON_SIZE.medium,
    iconType = _Icon.ICON_TYPE.solid,
    onTileClick,
    isSelected = false,
    testId,
    ...props
  } = _ref;
  const handleTileClick = e => {
    onTileClick?.(e, id);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.ClickableCard, {
    ...props,
    ref: ref,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'wrapper'
    }),
    classNames: {
      wrapper: (0, _classify.default)(_RadioTileModule.default.wrapper, classNames?.wrapper)
    },
    onClick: handleTileClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _RadioTileModule.default.iconContainer,
      children: !!iconName && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.SemanticIcon, {
        semantic: semantic,
        name: iconName,
        size: iconSize,
        type: iconType,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'icon'
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _RadioTileModule.default.contentContainer,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _RadioTileModule.default.textContainer,
        children: [!!header && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.SubTitleMedium, {
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'header'
          }),
          children: header
        }), !!description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.BodyMedium, {
          color: "secondary",
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'description'
          }),
          children: description
        })]
      }), !!chipItems?.length && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _RadioTileModule.default.chipsContainer,
        children: chipItems.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.Chip
        // eslint-disable-next-line react/no-array-index-key
        , {
          semantic: "primary",
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'chip',
            index: index.toString()
          }),
          children: item
        }, index))
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _RadioTileModule.default.btnContainer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadioButton.RadioButton, {
        classNames: {
          wrapper: _RadioTileModule.default.radioButtonWrapper
        },
        value: id,
        selectedValue: isSelected ? id : '',
        tabIndex: -1,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'radio-button'
        })
      })
    })]
  });
});